import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { Button } from "reactstrap"

export default class InputAndOutputPerson extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            month: 0,
            comId:0
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/inputandoutputperson/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    setValueRow(id, value, field) {
        for (var i = 0; i < this.state.data.record.inputAndOutputPersonsDto.length; i++) {
            if (this.state.data.record.inputAndOutputPersonsDto[i].id === id) {
                this.state.data.record.inputAndOutputPersonsDto[i][field] = value;

            }
        }
        this.setState({
            data: this.state.data
        })
    }



    loadPersonsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getpersons/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status === 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.fullName
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };

    loadDataCash() {
        setTimeout(() => {
            fetch("/api/v1/inputandoutputperson/getdaymonth?month=" + this.state.month + "&person=" + this.state.comId)
                .then(response => response.json())
                .then(response => {

                    this.setState({
                        data: response,
                        loading: false
                    })
                })
        }, 50);
    };
    setMoth(e) {
        this.state.month = e;
        this.setState({ data: this.state.data });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/inputandoutputperson/save", {

            month: this.state.data.record.months,
            year: this.state.data.record.year,
            personId: this.state.data.record.personId,
            details: this.state.data.record.inputAndOutputPersonsDto
         

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/inputandoutputpersons/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    changeType(type) {
        this.state.data.record.type = type;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">

                                        <div className="card-inner">
                                            <div className="tab-content">
                                                <div className="tab-pane active" id="base">
                                                    <div className="card-inner p-0">
                                                    
                                                        <div className="row">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">نام پرسنل</label>
                                                                    <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.comId > 0 ? [{ value: this.state.comId, label: this.state.name }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب محل صدور"
                                                                            defaultOptions
                                                                            isSearchable
                                                                            loadOptions={this.loadPersonsOptions}
                                                                                onChange={e => this.state.comId = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">ماه</label>
                                                                    <div className="form-control-wrap">
                                                                            <select className="form-control" type="text" onChange={e => this.setMoth(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب ماه</option>
                                                                            <option value="1">فروردین</option>
                                                                            <option value="2">اردیبهشت</option>
                                                                            <option value="3">خرداد</option>
                                                                            <option value="4">تیر</option>
                                                                            <option value="5">مرداد</option>
                                                                            <option value="6">شهریور</option>
                                                                            <option value="7">مهر</option>
                                                                            <option value="8">آبان</option>
                                                                            <option value="9">آذر</option>
                                                                            <option value="10">دی</option>
                                                                            <option value="11">بهمن</option>
                                                                            <option value="12">اسفند</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">برای ایجاد روز کاری دکمه ثبت را بزنید</label>
                                                                    <div className="form-control-wrap">
                                                                        <div className="btn-wrap">
                                                                            <span className="d-none d-md-block"><button type="button" onClick={e => this.loadDataCash()} className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em>ثبت </button></span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            {this.state.data.record.inputAndOutputPersonsDto.length > 0 &&
                                <div className="row">
                                    <div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">

                                            <div className="card-inner">
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="base">
                                                        <div className="card-inner p-0">

                                                            <div className="row g-gs">
                                                                <div className="col-xxl-3">
                                                                    <h6 className="title">
                                                                        نام:<span className="text-info">{this.state.data.record.detailPersonModel.firstName}</span>
                                                                    </h6>
                                                                    <h6 className="title">
                                                                        نام خانوادگی: <span className="text-info">{this.state.data.record.detailPersonModel.lastName} </span>
                                                                    </h6>
                                                                </div>
                                                                <div className="col-xxl-3">
                                                                    <h6 className="title">
                                                                        کد پرسنلی : <span className="text-info">{this.state.data.record.detailPersonModel.codePerson}</span>
                                                                    </h6>
                                                                    <h6 className="title">
                                                                        شماره قرارداد: <span className="text-info"> {this.state.data.record.detailPersonModel.contratoCode}</span>
                                                                    </h6>
                                                                </div>
                                                                <div className="col-xxl-3">
                                                                    <h6 className="title">
                                                                        شماره حساب: <span className="text-info">{this.state.data.record.detailPersonModel.accountNumber}</span>
                                                                    </h6>
                                                                    <h6 className="title">
                                                                        دوره: <span className="text-info">{this.state.data.record.detailPersonModel.title}</span>
                                                                    </h6>
                                                                </div>
                                                                <div class="col-xxl-3">
                                                                    <h6 class="title">
                                                                        میزان مرخصی باقیمانده:  <span className="text-info"></span>

                                                                    </h6>
                                                                  

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <br/>
                            <div className="row">
                                <div className="col-xxl-12">
                                    <div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">

                                            <div className="card-inner">
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="base">
                                                        <div className="card-inner p-0">
                                                            <div className="nk-tb-list nk-tb-ulist">
                                                                <div className="nk-tb-item nk-tb-head w-60px flex-fill p-2 bg-dark text-white">
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">تاریخ</span></div>
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">زمان ورود</span></div>
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">زمان خروج</span></div>
                                                           
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">میزان غیبت</span></div>
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">میزان ماموریت</span></div>
                                                                    <div className="nk-tb-col" style={{
                                                                        width: "150px",
                                                                        height: "34px",
                                                                        fontSize: "14px",

                                                                    }}><span className="sub-text text-center text-white">میزان مرخصی</span></div>

                                                                </div>
                                                                {this.state.data.record.inputAndOutputPersonsDto.map((record, index) =>
                                                                    <div className="nk-tb-item">
                                                                        <div className="nk-tb-col tb-col-md">
                                                                            <span className="sub-text text-center">{record.dateInAndOutStr}</span>

                                                                        </div>

                                                                        <div className="nk-tb-col tb-col-sm ">
                                                                            {/*<TimePicker position="bottom"*/}
                                                                            {/*    value={record.timeInput}*/}
                                                                            {/*/>*/}
                                                                            <DatePicker
                                                                                onChange={e => this.setValueRow(record.id, e.toString(), 'timeInput')}
                                                                                disableDayPicker
                                                                                value={record.timeInput}
                                                                                style={{
                                                                                    width: "150px",
                                                                                    height: "34px",
                                                                                    fontSize: "14px",
                                                                      
                                                                                }}
                                                                                format="HH:mm:ss"
                                                                                plugins={[
                                                                                    <TimePicker />
                                                                                ]}
                                                                                calendar={persian}
                                                                                locale={persian_fa}
                                                                                calendarPosition="bottom-right"
                                                                            />
                                                                        </div>
                                                                        <div className="nk-tb-col tb-col-md ">
                                                                            {/*<TimePicker position="bottom"*/}
                                                                            {/*    value={record.timeOut}*/}
                                                                            {/*/>*/}
                                                                            <DatePicker
                                                                                onChange={e => this.setValueRow(record.id, e.toString(), 'timeOut')}
                                                                                value={record.timeOut}
                                                                                style={{
                                                                                    width: "150px",
                                                                                    height: "34px",
                                                                                    fontSize: "14px",
                                                                                    padding: "3px 10px"
                                                                                }}
                                                                                disableDayPicker
                                                                                format="HH:mm:ss"
                                                                                plugins={[
                                                                                    <TimePicker />
                                                                                ]}
                                                                                calendar={persian}
                                                                                locale={persian_fa}
                                                                                calendarPosition="bottom-right"
                                                                            />
                                                                        </div>
                                                                     
                                                                       
                                                                       
                                                                        <div className="nk-tb-col tb-col-md ">
                                                                            {/*<TimePicker position="bottom"*/}
                                                                            {/*    value={record.conflict}*/}
                                                                            {/*/>*/}
                                                                            <input type="checkbox" className="custom-control-input" id={"A" + record.id.toString()} defaultValue={record.isAbsence} onChange={e => this.setValueRow(record.id, e.target.checked, "isAbsence")} />
                                                                            <label className="custom-control-label" htmlFor={"A" + record.id}></label>
                                                                            {record.isAbsence === true &&
                                                                                <DatePicker
                                                                                    onChange={e => this.setValueRow(record.id, e.toString(), 'absence')}

                                                                                    value={record.absence}
                                                                                    style={{
                                                                                        width: "150px",
                                                                                        height: "34px",
                                                                                        fontSize: "14px",
                                                                                        padding: "3px 10px"
                                                                                    }}
                                                                                    disableDayPicker
                                                                                    format="HH:mm:ss"
                                                                                    plugins={[
                                                                                        <TimePicker />
                                                                                    ]}
                                                                                    calendar={persian}
                                                                                    locale={persian_fa}
                                                                                    calendarPosition="bottom-right"
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div className="nk-tb-col tb-col-md ">
                                                                            {/*<TimePicker position="bottom"*/}
                                                                            {/*    value={record.conflict}*/}
                                                                            {/*/>*/}
                                                                            <input type="checkbox" className="custom-control-input" id={"M" + record.id.toString()} defaultValue={record.isMission} onChange={e => this.setValueRow(record.id, e.target.checked, "isMission")} />
                                                                            <label className="custom-control-label" htmlFor={"M" +record.id}></label>
                                                                           
                                                                            {record.isMission === true &&
                                                                                <DatePicker
                                                                                onChange={e => this.setValueRow(record.id, e.toString(), 'mission')}

                                                                                    value={record.mission}
                                                                                    style={{
                                                                                        width: "150px",
                                                                                        height: "34px",
                                                                                        fontSize: "14px",
                                                                                        padding: "3px 10px"
                                                                                    }}
                                                                                    disableDayPicker
                                                                                    format="HH:mm:ss"
                                                                                    plugins={[
                                                                                        <TimePicker />
                                                                                    ]}
                                                                                    calendar={persian}
                                                                                    locale={persian_fa}
                                                                                    calendarPosition="bottom-right"
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div className="nk-tb-col tb-col-md ">
                                                                            {/*<TimePicker position="bottom"*/}
                                                                            {/*    value={record.conflict}*/}
                                                                            {/*/>*/}
                                                                            <input type="checkbox" className="custom-control-input" id={"L" + record.id.toString()} defaultValue={record.isLeave} onChange={e => this.setValueRow(record.id, e.target.checked, "isLeave")} />
                                                                            <label className="custom-control-label" htmlFor={"L" + record.id}></label>
                                                                            {record.isLeave === true &&
                                                                                <select style={{
                                                                                    width: "150px",
                                                                                    height: "34px",
                                                                                }} className="form-control" type="text" defaultValue={record.typeLeave} onChange={e => this.setValueRow(record.id, parseInt(e.target.value), "typeLeave")}>
                                                                                    <option value="1">استعلاجی</option>
                                                                                    <option value="2">استهقاقی</option>
                                                                                </select>
                                                                            }
                                                                            {record.isLeave === true &&
                                                                                <DatePicker
                                                                                    onChange={e => this.setValueRow(record.id, e.toString(), 'leave')}

                                                                                    value={record.leave}

                                                                                    style={{
                                                                                        width: "150px",
                                                                                        height: "34px",
                                                                                        fontSize: "14px",
                                                                                        padding: "3px 10px"
                                                                                    }}
                                                                                    disableDayPicker
                                                                                    format="HH:mm:ss"
                                                                                    plugins={[
                                                                                        <TimePicker />
                                                                                    ]}
                                                                                    calendar={persian}
                                                                                    locale={persian_fa}
                                                                                    calendarPosition="bottom-right"
                                                                                />
                                                                            }
                                                                        
                                                                        </div>
                                                                    </div>
                                                                )}


                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>





                                        </div>
                                    </div>
                                </div>

                
                            </div>
                            <br />
                            {this.state.data.record.inputAndOutputPersonsDto.length>0 &&
                                <div className="row">
                                    <div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">

                                            <div className="card-inner">
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="base">
                                                        <div className="card-inner p-0">

                                                            <div className="row">
                                                                <div className="col-lg-4">
                                                                    <div className="form-group">
                                                                        <button type="submit" className="btn btn-lg btn-primary">ثبت اطلاعات</button>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                       

                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}